import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-list-icon',
  templateUrl: './generic-list-icon.component.html',
  styleUrls: ['./generic-list-icon.component.scss']
})
export class GenericListIconComponent implements OnInit {
  @Input() icon: string;
  matIcon: string;
  svgIcon: string;

  constructor() {}

  ngOnInit(): void {
    if (this.icon.startsWith('uz-') || this.icon.startsWith('uz_')) {
      this.svgIcon = this.icon;
    } else {
      this.matIcon = this.icon;
    }
  }
}
